import { useContext } from 'react'
import { ChecklistDetailPopupContext } from './checklistDetailPopupContextCore'

export const useChecklistDetailPopup = () => {
  const context = useContext(ChecklistDetailPopupContext)
  if (!context) throw new Error('useChecklistDetailPopup must be used within ChecklistDetailPopupProvider')
  return context
}
